import React, { useEffect, useState } from "react";
import { FaPencilAlt } from "react-icons/fa";

const STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa",
  "Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala",
  "Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland",
  "Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
  "Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands",
  "Chandigarh","Dadra and Nagar Haveli and Daman and Diu","Delhi",
  "Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"
];

const REGIONS = ["North", "South", "East", "West", "Central"];

const Zones = () => {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const [editingZone, setEditingZone] = useState(null);

  const [alert, setAlert] = useState({
    open: false,
    type: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    zone_number: "",
    zone_name: "",
    state: "",
    pincode: "",
    region: "",
  });

  useEffect(() => {
    fetchZones();
  }, []);

  const showAlert = (type, message) => {
    setAlert({ open: true, type, message });
    setTimeout(() => {
      setAlert({ open: false, type: "", message: "" });
    }, 3000);
  };

  const fetchZones = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}zone/get-all-zones`
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch zones");
      }

      setZones(result.data || []);
    } catch (error) {
      showAlert("error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingZone(null);

    setFormData({
      zone_number: "",
      zone_name: "",
      state: "",
      pincode: "",
      region: "",
    });
  };

  const handleEdit = (zone) => {
    setEditingZone(zone);

    setFormData({
      zone_number: zone.zone_number || "",
      zone_name: zone.zone_name || "",
      state: zone.state || "",
      pincode: zone.pincode || "",
      region: zone.region || "",
    });

    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const url = editingZone
        ? `${process.env.REACT_APP_FORE_BRICKBUCKET}zone/update-zone?_id=${editingZone._id}`
        : `${process.env.REACT_APP_FORE_BRICKBUCKET}zone/create-zone`;

      const method = editingZone ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Something went wrong");
      }

      showAlert(
        "success",
        editingZone
          ? "Zone updated successfully"
          : "Zone created successfully"
      );

      closeModal();
      fetchZones();
    } catch (error) {
      showAlert("error", error.message);
    } finally {
      setSaving(false);
    }
  };

  const filteredZones = zones.filter((zone) => {
    const s = search.toLowerCase();

    return (
      zone.zone_number?.toLowerCase().includes(s) ||
      zone.zone_name?.toLowerCase().includes(s) ||
      zone.state?.toLowerCase().includes(s) ||
      zone.pincode?.includes(search)
    );
  });

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {alert.open && (
        <div className={`fixed top-5 right-5 z-50 rounded-lg px-4 py-3 text-white shadow-lg ${alert.type === "success" ? "bg-green-600" : "bg-red-600"}`}>
          {alert.message}
        </div>
      )}

      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-bold">Zones List</h1>
          <p className="text-sm text-gray-500">Create and manage zones</p>
        </div>

        <button
          onClick={() => setShowModal(true)}
          className="rounded-lg bg-[#F7525A] px-4 py-2 text-white"
        >
          + Add Zone
        </button>
      </div>

      <input
        type="text"
        placeholder="Search zones..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-4 w-full max-w-md rounded-lg border px-4 py-2"
      />

      <div className="overflow-hidden rounded-xl bg-white shadow">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-3 text-left">Zone Number</th>
                <th className="px-4 py-3 text-left">Zone Name</th>
                <th className="px-4 py-3 text-left">State</th>
                <th className="px-4 py-3 text-left">Region</th>
                <th className="px-4 py-3 text-left">Pincode</th>
                <th className="px-4 py-3 text-left">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="py-10">
                    <div className="flex justify-center">
                      <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" />
                    </div>
                  </td>
                </tr>
              ) : filteredZones.length === 0 ? (
                <tr>
                  <td colSpan="5" className="py-10 text-center">
                    No zones found
                  </td>
                </tr>
              ) : (
                filteredZones.map((zone) => (
                  <tr key={zone._id} className="border-t">
                    <td className="px-4 py-3">{zone.zone_number}</td>
                    <td className="px-4 py-3">{zone.zone_name}</td>
                    <td className="px-4 py-3">{zone.state}</td>
                    <td className="px-4 py-3">{zone.region}</td>
                    <td className="px-4 py-3">{zone.pincode}</td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => handleEdit(zone)}
                        className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300"
                      >
                        <FaPencilAlt /> 
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-lg rounded-xl bg-white p-6">
            <div className="mb-5 flex items-center justify-between">
              <h2 className="text-xl font-semibold">
                {editingZone ? "Edit Zone" : "Create Zone"}
              </h2>

              <button onClick={closeModal}>✕</button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                name="zone_number"
                value={formData.zone_number}
                onChange={handleChange}
                placeholder="Zone Number"
                className="w-full rounded-lg border px-3 py-2"
                required
              />

              <input
                name="zone_name"
                value={formData.zone_name}
                onChange={handleChange}
                placeholder="Zone Name"
                className="w-full rounded-lg border px-3 py-2"
                required
              />

              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="w-full rounded-lg border px-3 py-2"
              >
                <option value="">Select State</option>
                {STATES.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>

              <select
                name="region"
                value={formData.region}
                onChange={handleChange}
                className="w-full rounded-lg border px-3 py-2"
              >
                <option value="">Select Region</option>
                {REGIONS.map((region) => (
                  <option key={region} value={region}>
                    {region}
                  </option>
                ))}
              </select>

              <input
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                placeholder="Pincode"
                className="w-full rounded-lg border px-3 py-2"
              />

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={closeModal}
                  className="rounded-lg border px-4 py-2"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={saving}
                  className="rounded-lg bg-[#F7525A] px-4 py-2 text-white"
                >
                  {saving
                    ? "Saving..."
                    : editingZone
                    ? "Update Zone"
                    : "Save Zone"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Zones;
